<template>
    <div class="selectbox-question" :class="{ 'is-list': showList }">
        <label
            class="question-label"
            v-bind:class="{ error: valid === false, valid: valid === true }"
            ><slot name="label"></slot
        ></label>

        <!-- Desktop multiselect: every option visible, one click each. -->
        <div class="choice-hint" v-if="showList && multiselect">
            {{ t("question-select_options") }}
        </div>
        <div
            v-if="showList"
            class="choice-list"
            role="group"
        >
            <label
                v-for="option in filterOptions"
                :key="option.order"
                class="choice"
                :class="{ checked: isChecked(option) }"
            >
                <input
                    :type="multiselect ? 'checkbox' : 'radio'"
                    :name="inputName"
                    :checked="isChecked(option)"
                    @change="toggle(option)"
                    @focus="$emit('focus')"
                />
                <span class="choice-mark" aria-hidden="true"></span>
                <span class="choice-text">{{ option.text }}</span>
            </label>
        </div>

        <div class="options" v-else>
            <div class="field">
                <select
                    class="form-control"
                    type="text"
                    v-model="currentValue.option"
                    :multiple="multiselect"
                    @focus="$emit('focus')"
                >
                    <option :value="null">
                        {{
                            multiselect
                                ? t("question-select_options")
                                : t("question-select_option")
                        }}
                    </option>
                    <option
                        v-for="option in filterOptions"
                        :key="option.order"
                        :value="option"
                    >
                        {{ option.text }}
                    </option>
                </select>
            </div>
        </div>

        <div class="question-error" v-if="valid === false && error">
            {{ error }}
        </div>
    </div>
</template>
<script>
import viewport from "../../utils/viewport";

let uid = 0;

export default {
    name: "selectbox-question",
    props: {
        value: {
            type: Object,
            default: () => {
                return {
                    option: [],
                };
            },
        },
        options: {
            type: Array,
            default: () => [
                /*
        {
          removed: false,
          new: false,
          text: "Opção 1",
          order: 1,
        },
        ...
        */
            ],
        },
        multiselect: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        filterOptions() {
            return this.options.filter((op) => op.removed === false);
        },
        // Desktop multiselect: checkboxes instead of a ctrl/cmd-click list.
        // Single choice stays a dropdown everywhere.
        showList() {
            return viewport.desktop && this.multiselect;
        },
    },
    data() {
        uid += 1;
        return {
            currentValue: {
                option: this.multiselect ? [] : null,
            },
            inputName: "selectbox-" + uid,
            error: null,
            valid: null,
        };
    },
    methods: {
        isChecked: function (option) {
            if (this.multiselect) {
                return this.currentValue.option.indexOf(option) !== -1;
            }
            return this.currentValue.option === option;
        },
        toggle: function (option) {
            if (!this.multiselect) {
                this.currentValue.option = option;
                return;
            }
            const selected = this.currentValue.option.filter(
                (item) => item !== null,
            );
            const index = selected.indexOf(option);
            if (index === -1) {
                selected.push(option);
            } else {
                selected.splice(index, 1);
            }
            // Keep the options' order, not the click order.
            this.currentValue.option = this.filterOptions.filter(
                (item) => selected.indexOf(item) !== -1,
            );
        },
        isValid: function () {
            this.valid = null;
            if (this.isNull()) {
                this.valid = false;
                this.error = this.t("question-select_at_least_one");
                return false;
            }
            this.valid = true;
            return true;
        },
        getValue: function () {
            if (this.multiselect) {
                return this.currentValue.option.map((op) =>
                    op ? op.text : null,
                );
            }
            return this.currentValue.option
                ? [this.currentValue.option.text]
                : [];
        },
        isNull: function () {
            if (this.multiselect) {
                return (
                    this.currentValue.option.length === 0 ||
                    Object.values(this.currentValue.option).includes(null)
                );
            }
            return !this.currentValue.option || !this.currentValue.option.text;
        },
    },
    watch: {
        "currentValue.option"() {
            this.isValid();
            this.$emit("change", this.getValue());
        },
    },
};
</script>
